import * as React from "react";
import { EventCardPropsMapper } from "../../../../../helpers/CardProps";
import { RenderCard } from "../RenderCard/RenderCard";
export const renderInternalEvents = (state, endIndex, startIndex, events, cms, dict) => {
    let innerView = [];
    for (startIndex; startIndex < endIndex; startIndex++) {
        let sportEvent = events[startIndex];
        let props = EventCardPropsMapper[sportEvent.type](state, sportEvent, cms, dict);
        innerView.push(React.createElement(RenderCard, Object.assign({ key: `k_card_${startIndex}` }, props)));
    }
    return innerView;
};
//# sourceMappingURL=renderInternalEvents.js.map